import { loadChargebeeScript } from '@/../vendors/chargebee/init-chargebee'
import Vue from 'vue'

type Params = {
    getPayloadRequest: () => Promise<unknown>
    onSuccess?: () => unknown
    onError?: (error: unknown) => unknown
}

const ChargebeeMixin = Vue.extend({
    methods: {
        async openCheckoutModal(params: Params) {
            if (!process.env.VUE_APP_CHARGEBEE_SITE) {
                throw new Error('VUE_APP_CHARGEBEE_SITE env var missing')
            }

            if (!window.Chargebee) {
                await loadChargebeeScript()

                if (!window.Chargebee) {
                    throw new Error('Chargebee script not loaded')
                }
            }

            const chargebeeInstance: any = window.Chargebee.init({
                site: process.env.VUE_APP_CHARGEBEE_SITE,
                isItemsModel: true, // Product catalog 2.0
            })

            chargebeeInstance.openCheckout({
                hostedPage: params.getPayloadRequest,
                success: params.onSuccess,
                error: params.onError,
            })
        },
    },
})

export default ChargebeeMixin
